import {getFormattedLocation} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../commons/hooks/dates'
import {useMobileFontOverrides} from '../../../../../commons/hooks/use-mobile-font-overrides'
import {useVisibilityStyles} from '../../hooks/use-visibility-styles'
import sc from '../classes.scss'
import s from './short-date-location.scss'
import {ShortDateLocationProps} from '.'

export const ShortDateLocation = ({event, dateClassName, locationClassName}: ShortDateLocationProps) => {
  const {shortStartDate} = useEventDateInformation(event.id)
  const {
    allBreakpoints: {isListVenueNameEnabled, isListDateEnabled},
  } = useVisibilityStyles()
  const venueVisible = isListVenueNameEnabled()
  const dateVisible = isListDateEnabled()
  const {mobileFontOverridesEnabled} = useMobileFontOverrides()

  return (
    <div className={classNames(s.container, sc.textLineHeight, s.alignment)} data-hook="ev-short-date-location">
      {dateVisible ? (
        <div className={classNames(s.date, {[dateClassName]: !mobileFontOverridesEnabled})} data-hook="short-date">
          {shortStartDate}
        </div>
      ) : null}
      <div className={classNames(s.divider, {[dateClassName]: !mobileFontOverridesEnabled})} />
      {venueVisible ? (
        <div
          className={classNames(s.location, {[locationClassName]: !mobileFontOverridesEnabled})}
          data-hook="short-location"
        >
          {getFormattedLocation(event)}
        </div>
      ) : null}
    </div>
  )
}
